import utils from '@/js/utils';
import MENU_CHATBOT from '@/configs/menus/ch.menu';
export default [{
  path: '/Chatbots/PermissionManagement',
  name: 'ChatbotsPermissionManagement',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/ChatbotsPermissionManagement');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT)
  }
}, {
  path: '/Chatbots/UserManagement',
  name: 'ChatbotsUserManagement',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/ChatbotsUserManagement');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT)
  }
}, {
  path: '/Chatbots/UserPermissionManagement',
  name: 'ChatbotsUserPermissionManagement',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/ChatbotsUserPermissionManagement');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT)
  }
}, /* Channels Management */
{
  path: '/Chatbots/ChannelManagement',
  name: 'ChannelManagement',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/channels/ListChannels.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    corporate: true
  }
}, /* Dashboard */
{
  path: '/Chatbots/Dashboard',
  name: 'Dashboard',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/dashboard/ViewDashboard.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT)
  }
}, {
  path: '/Chatbots/ChannelManagement/Create',
  name: 'ChannelManagementCreate',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/channels/CreateChannel.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    mode: 'create',
    corporate: true
  }
}, {
  path: '/Chatbots/ChannelManagement/Update/:id',
  name: 'ChannelManagementUpdate',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/channels/CreateChannel.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    mode: 'edit',
    corporate: true
  }
}, {
  path: '/Chatbots/ChannelManagement/View/:id',
  name: 'ChannelManagementView',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/channels/CreateChannel.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    mode: 'view',
    corporate: true
  }
}, {
  path: '/Chatbots/ProjectManagement',
  name: 'ProjectManagement',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/projects/ListProjects.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT)
  }
}, {
  path: '/Chatbots/ProjectManagement/Create',
  name: 'ProjectManagementCreate',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/projects/CreateProject.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    mode: "create"
  }
}, {
  path: '/Chatbots/ProjectManagement/Update/:id',
  name: 'ProjectManagementUpdate',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/projects/CreateProject.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    mode: 'edit'
  }
}, {
  path: '/Chatbots/ProjectManagement/View/:id',
  name: 'ProjectManagementView',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/projects/CreateProject.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    mode: 'view',
    check_flag: 'data-platform/has_hub_ia_active'
  }
}, {
  path: '/Chatbots/DataCenter',
  name: 'DataCenter',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/datacenter/ListDataCenter.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT)
  }
}, {
  path: '/Chatbots/DataCenter/View/:id',
  name: 'DataCenterView',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/datacenter/CreateDataCenter.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    mode: 'view'
  }
}, {
  path: '/Chatbots/DataCenter/Edit/:id',
  name: 'DataCenterUpdate',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/datacenter/CreateDataCenter.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    mode: "edit"
  }
}, {
  path: '/Chatbots/DataCenter/Create',
  name: 'DataCenterCreate',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/datacenter/CreateDataCenter.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    mode: 'create'
  }
}, {
  path: '/Chatbots/BotsManagement',
  name: 'BotsManagement',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/chatbots/ListBots.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    corporate: true,
    check_flag: 'data-platform/has_hub_ia_active'
  }
}, /* Dashboard */
{
  path: '/Chatbots/SearchEngine',
  name: 'SearchEngine',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/searchengine/ListSearchEngine.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    corporate: true,
    check_flag: 'data-platform/has_hub_ia_active'
  }
}, {
  path: '/Chatbots/ChatbotConfig',
  name: 'ChatbotConfig',
  component: function component() {
    return import(/* webpackChunkName: "apps-chatbot" */'@/apps/chatbots/modules/config/ChatbotConfig.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('chatbot_view', MENU_CHATBOT),
    corporate: true,
    check_flag: 'data-platform/has_hub_ia_active'
  }
}];